import { lazy } from 'react';
import { registerSection } from '@/modules/shared/registry/sectionRegistry';

export { default as CvScreeningTab } from './components/CvScreeningTab';
export { cvScreeningApi } from './services/cv-screening.api';
export { deriveScreeningStatuses } from './services/derive-statuses';
export type {
    CvScreener,
    Criterion,
    ProfileStrengthComponent,
    VerdictCondition,
    VerdictRule,
    ConditionField,
    ConditionOperator,
    CvScreeningResult,
    CriteriaResult,
    ProfileStrengthResult,
} from './services/cv-screening.api';

registerSection({
    stageType: 'screening',
    label: 'CV Screening',
    component: lazy(() => import('./components/CvScreeningReport')),
    supportsMultipleResults: true,
});
